__turbopack_context__.v({
  "container_singleColumn": "SingleColumnLayout-module__bvM7ea__container_singleColumn",
  "similarTitlesLayout": "SingleColumnLayout-module__bvM7ea__similarTitlesLayout",
});
